module.exports = __webpack_public_path__ + "img/黑桃初级大师@2x.c13af25c.png";